// import { currentSelectedNetwork } from 'AppSrc/core/components/forms/form-types/create-crq/common-logic';
import {
  getCrqList,
  getNotificationComms,
  getNotificationCommsDetailed,
  flAddApprover,
  individualAddApprover,
} from './crq-queries';


// Fetch (GET) CRQ from API
const FETCH_CRQ_LIST_REQUEST = 'FETCH_CRQ_LIST_REQUEST';
const FETCH_CRQ_LIST_SUCCESS = 'FETCH_CRQ_LIST_SUCCESS';
const FETCH_CRQ_LIST_ERROR = 'FETCH_CRQ_LIST_ERROR';
const CLEAR_CRQ_LIST = 'CLEAR_CRQ_LIST';
const CLEAR_CRQ_LIST_ERROR = 'CLEAR_CRQ_LIST_ERROR';
// Fetch (GET) notificationComms from API
const FETCH_NOTIFICATION_COMMS_REQUEST = 'FETCH_NOTIFICATION_COMMS_REQUEST';
const FETCH_NOTIFICATION_COMMS_SUCCESS = 'FETCH_NOTIFICATION_COMMS_SUCCESS';
const FETCH_NOTIFICATION_COMMS_ERROR = 'FETCH_NOTIFICATION_COMMS_ERROR';
// Fetch (GET) notificationComms from API Detailed
const FETCH_NOTIFICATION_COMMS__DETAILED_REQUEST = 'FETCH_NOTIFICATION_COMMS_DETAILED_REQUEST';
const FETCH_NOTIFICATION_COMMS_DETAILED_SUCCESS = 'FETCH_NOTIFICATION_COMMS_DETAILED_SUCCESS';
const FETCH_NOTIFICATION_COMMS_DETAILED_ERROR = 'FETCH_NOTIFICATION_COMMS_DETAILED_ERROR';
// FL Add approver post call
const FL_ADD_APPROVER_CRQ_REQUEST = 'FL_ADD_APPROVER_CRQ_REQUEST';
const FL_ADD_APPROVER_CRQ_SUCCESS = 'FL_ADD_APPROVER_CRQ_SUCCESS';
const FL_ADD_APPROVER_CRQ_ERROR = 'FL_ADD_APPROVER_CRQ_ERROR';
const IND_ADD_APPROVER_CRQ_REQUEST = 'IND_ADD_APPROVER_CRQ_REQUEST';
const IND_ADD_APPROVER_CRQ_SUCCESS = 'IND_ADD_APPROVER_CRQ_SUCCESS';
const IND_ADD_APPROVER_CRQ_ERROR = 'IND_ADD_APPROVER_CRQ_ERROR';

// FL Add approver post call
// const FL_ADD_APPROVER_CRQ_REQUEST = 'FL_ADD_APPROVER_CRQ_REQUEST';
// const FL_ADD_APPROVER_CRQ_SUCCESS = 'FL_ADD_APPROVER_CRQ_SUCCESS';
// const FL_ADD_APPROVER_CRQ_ERROR = 'FL_ADD_APPROVER_CRQ_ERROR';

/* - fetch CRQ synchronous actions - */

const fetchCrqListRequest = (params) => ({
  type: FETCH_CRQ_LIST_REQUEST,
  payload: {
    params,
  },
});

const fetchCrqListSuccess = (params, results) => ({
  type: FETCH_CRQ_LIST_SUCCESS,
  payload: {
    params,
    results,
  },
});

const fetchCrqListError = (params, error) => ({
  type: FETCH_CRQ_LIST_ERROR,
  payload: {
    params,
    error,
  },
});

// IND ADD approver
const indAddApproverGroupsToCrqRequest = (network, crqId) => ({
  type: IND_ADD_APPROVER_CRQ_REQUEST,
  payload: {
    network,
    crqId,
  },
});

const indAddApproverGroupsToCrqSuccess = (network, crqId, data) => ({
  type: IND_ADD_APPROVER_CRQ_SUCCESS,
  payload: {
    network,
    crqId,
    data,
  },
});

const indAddApproverGroupsToCrqError = (network, crqId, error) => ({
  type: IND_ADD_APPROVER_CRQ_ERROR,
  payload: {
    network,
    crqId,
    error,
  },
});

const clearCrqList = () => ({
  type: CLEAR_CRQ_LIST,
  payload: {
  },
});

const clearCrqListError = () => ({
  type: CLEAR_CRQ_LIST_ERROR,
  payload: {},
});
// FL ADD approver
const flAddApproverGroupsToCrqRequest = (network, crqId) => ({
  type: FL_ADD_APPROVER_CRQ_REQUEST,
  payload: {
    network,
    crqId,
  },
});

const flAddApproverGroupsToCrqSuccess = (network, crqId, data) => ({
  type: FL_ADD_APPROVER_CRQ_SUCCESS,
  payload: {
    network,
    crqId,
    data,
  },
});

const flAddApproverGroupsToCrqError = (network, crqId, error) => ({
  type: FL_ADD_APPROVER_CRQ_ERROR,
  payload: {
    network,
    crqId,
    error,
  },
});

const fetchCrqList = (params) => (dispatch) => {
  dispatch(fetchCrqListRequest(params));
  return getCrqList(params).then(
    (data) => dispatch(fetchCrqListSuccess(params, data)),
  ).catch(
    (error) => dispatch(fetchCrqListError(params, error)),
  );
};

const fetchNotificationCommsRequest = (params) => ({
  type: FETCH_NOTIFICATION_COMMS_REQUEST,
  payload: {
    params,
  },
});

const fetchNotificationCommsSuccess = (params, results) => ({
  type: FETCH_NOTIFICATION_COMMS_SUCCESS,
  payload: {
    params,
    results,
  },
});

const fetchNotificationCommsError = (params, error) => ({
  type: FETCH_NOTIFICATION_COMMS_ERROR,
  payload: {
    params,
    error,
  },
});

const fetchNotificationComms = (params) => (dispatch) => {
  dispatch(fetchNotificationCommsRequest(params));
  return getNotificationComms(params).then(
    (data) => dispatch(fetchNotificationCommsSuccess(params, data)),
  ).catch(
    (error) => dispatch(fetchNotificationCommsError(params, error)),
  );
};

const fetchNotificationCommsDetailedRequest = (params) => ({
  type: FETCH_NOTIFICATION_COMMS__DETAILED_REQUEST,
  payload: {
    params,
  },
});

const fetchNotificationCommsDetailedSuccess = (params, results) => ({
  type: FETCH_NOTIFICATION_COMMS_DETAILED_SUCCESS,
  payload: {
    params,
    results,
  },
});

const fetchNotificationCommsDetailedError = (params, error) => ({
  type: FETCH_NOTIFICATION_COMMS_DETAILED_ERROR,
  payload: {
    params,
    error,
  },
});

const fetchNotificationCommsDetailed = (params) => (dispatch) => {
  dispatch(fetchNotificationCommsDetailedRequest(params));
  return getNotificationCommsDetailed(params).then(
    (data) => dispatch(fetchNotificationCommsDetailedSuccess(params, data)),
  ).catch(
    (error) => dispatch(fetchNotificationCommsDetailedError(params, error)),
  );
};

// Fixed Add approver dispatch call with one or approvers
const individualAddApproverGroupsToCrq = (network, crqId, individualApprovers) => (dispatch) => {
  dispatch(indAddApproverGroupsToCrqRequest(network, crqId));
  // eslint-disable-next-line camelcase
  const promises = individualApprovers.map(({ email, full_name, id }) => individualAddApprover({
    network,
    crqId,
    email,
    full_name,
    id,
  }).then((data) => {
    dispatch(indAddApproverGroupsToCrqSuccess(individualApprovers));
  }));
  return Promise.all(promises)
    .then((data) => {
      dispatch(indAddApproverGroupsToCrqSuccess(network, crqId));
    }).catch((error) => {
      dispatch(indAddApproverGroupsToCrqError(network, crqId, error));
      return Promise.reject(error);
    });
};

// FL Add approver dispatch call
const flAddApproverGroupsToCrq = (network, crqId) => (dispatch) => {
  dispatch(flAddApproverGroupsToCrqRequest(network, crqId));
  return flAddApprover(network, crqId).then(
    (data) => {
      console.log('aadata', data);
      dispatch(flAddApproverGroupsToCrqSuccess(data));
      return data;
    },
  ).catch(
    (error) => dispatch(flAddApproverGroupsToCrqError(network, crqId, error)),
  );
};

export {
  fetchCrqList,
  FETCH_CRQ_LIST_ERROR,
  FETCH_CRQ_LIST_REQUEST,
  FETCH_CRQ_LIST_SUCCESS,
  CLEAR_CRQ_LIST,
  clearCrqList,
  CLEAR_CRQ_LIST_ERROR,
  clearCrqListError,
  // comms notification starts
  FETCH_NOTIFICATION_COMMS_REQUEST,
  FETCH_NOTIFICATION_COMMS_SUCCESS,
  FETCH_NOTIFICATION_COMMS_ERROR,
  fetchNotificationComms,
  FETCH_NOTIFICATION_COMMS__DETAILED_REQUEST,
  FETCH_NOTIFICATION_COMMS_DETAILED_SUCCESS,
  FETCH_NOTIFICATION_COMMS_DETAILED_ERROR,
  fetchNotificationCommsDetailed,
  FL_ADD_APPROVER_CRQ_REQUEST,
  FL_ADD_APPROVER_CRQ_SUCCESS,
  FL_ADD_APPROVER_CRQ_ERROR,
  flAddApproverGroupsToCrq,
  individualAddApproverGroupsToCrq,
};
